import MessageBox from '@/components/message-box'
import { getI18n } from '@/common/common-fn'

const enum MESSAGE_BOX_TYPES {
    Default = '',
    Prompt = 'prompt',
    Alert = 'alert',
    Confirm = 'confirm'
}

// https://element-plus.org/#/en-US/component/message-box

// export declare type Action = 'confirm' | 'close' | 'cancel';

interface MessageBoxOptions {
    // beforeClose?: (action: Action, instance: MessageBoxState, done: () => void) => void;
    customClass?: string;
    // callback?: Callback;
    cancelButtonText?: string;
    confirmButtonText?: string;
    ignoreButtonText?: string;
    cancelButtonClass?: string;
    confirmButtonClass?: string;
    ignoreButtonClass?: string;
    center?: boolean;
    message?: string;
    title?: string;
    // type?: MESSAGE_BOX_TYPES;
    boxType?: MESSAGE_BOX_TYPES;
    iconClass?: string;
    dangerouslyUseHTMLString?: boolean;
    distinguishCancelAndClose?: boolean;
    lockScroll?: boolean;
    showCancelButton?: boolean;
    showConfirmButton?: boolean;
    showIgnoreButton?: boolean;
    showClose?: boolean;
    roundButton?: boolean;
    closeOnClickModal?: boolean;
    closeOnPressEscape?: boolean;
    closeOnHashChange?: boolean;
    showInput?: boolean;
    inputPlaceholder?: string;
    inputValue?: string;
    inputPattern?: RegExp;
    inputType?: string;
    // inputValidator?: MessageBoxInputValidator;
    inputErrorMessage?: string;
}

class MMessageBox {
    private defaultOptions: MessageBoxOptions

    constructor () {
      this.defaultOptions = {
        title: getI18n('NotifyMessage.AppName'),
        message: '',
        dangerouslyUseHTMLString: false,
        customClass: 'ms-message-box',
        showCancelButton: true,
        showConfirmButton: true,
        cancelButtonText: getI18n('Controls.MessageBox.Cancel'),
        confirmButtonText: getI18n('Controls.MessageBox.Confirm'),
        ignoreButtonText: getI18n('Controls.MessageBox.Ignore'),
        closeOnClickModal: false,
        closeOnPressEscape: false,
        center: false,
        confirmButtonClass: 'ms-button',
        boxType: MESSAGE_BOX_TYPES.Default,
        showClose: false
      }
    }

    // Hiển thị MessageBox với option đưa ra
    show (options: Object) {
      const msgOptions = {
        ...this.defaultOptions,
        ...options
      }

      return MessageBox(msgOptions)
    }

    // Hiển thị Cảnh báo
    showAlert (message: string, options: Object) {
      const alertOptions = {
        boxType: MESSAGE_BOX_TYPES.Alert,
        message,
        showCancelButton: false
      }

      return this.show({ ...alertOptions, ...options })
    }

    /**
     * @description Hiển thị
     * @param message
     * @param callback
     * @param options
     */
    showConfirm (message: string, callback: Function, options: Object) {
      const confirmOptions = {
        boxType: MESSAGE_BOX_TYPES.Confirm,
        message,
        callback
      }

      return this.show({ ...confirmOptions, ...options })
    }

    /**
     * @description Hiển thị prompt
     * @param message
     * @param callback
     * @param options
     */
    showPrompt (message: string, callback: Function, options: Object) {
      const promptOptions = {
        boxType: MESSAGE_BOX_TYPES.Confirm,
        message,
        showInput: true,
        callback,
        inputType: 'text'
      }

      return this.show({ ...promptOptions, ...options })
    }
}

export default new MMessageBox()

// interface ElMessageBoxOptions {
//     beforeClose?: (action: Action, instance: MessageBoxState, done: () => void) => void;
//     customClass?: string;
//     callback?: Callback;
//     cancelButtonText?: string;
//     confirmButtonText?: string;
//     cancelButtonClass?: string;
//     confirmButtonClass?: string;
//     center?: boolean;
//     message?: string | VNode;
//     title?: string;
//     type?: MessageType;
//     boxType?: MessageBoxType;
//     iconClass?: string;
//     dangerouslyUseHTMLString?: boolean;
//     distinguishCancelAndClose?: boolean;
//     lockScroll?: boolean;
//     showCancelButton?: boolean;
//     showConfirmButton?: boolean;
//     showClose?: boolean;
//     roundButton?: boolean;
//     closeOnClickModal?: boolean;
//     closeOnPressEscape?: boolean;
//     closeOnHashChange?: boolean;
//     showInput?: boolean;
//     inputPlaceholder?: string;
//     inputValue?: string;
//     inputPattern?: RegExp;
//     inputType?: string;
//     inputValidator?: MessageBoxInputValidator;
//     inputErrorMessage?: string;
// }

// interface MessageBoxState {
//     title: string;
//     message: string;
//     type: MessageType;
//     iconClass: string;
//     customClass: string;
//     showInput: boolean;
//     inputValue: string;
//     inputPlaceholder: string;
//     inputType: string;
//     inputPattern: RegExp;
//     inputValidator: MessageBoxInputValidator;
//     inputErrorMessage: string;
//     showConfirmButton: boolean;
//     showCancelButton: boolean;
//     action: Action;
//     dangerouslyUseHTMLString: boolean;
//     confirmButtonText: string;
//     cancelButtonText: string;
//     confirmButtonLoading: boolean;
//     cancelButtonLoading: boolean;
//     confirmButtonClass: string;
//     confirmButtonDisabled: boolean;
//     cancelButtonClass: string;
//     editorErrorMessage: string;
//     beforeClose: null | ((action: Action, instance: MessageBoxState, done: () => void) => void);
//     callback: null | Callback;
//     distinguishCancelAndClose: boolean;
//     modalFade: boolean;
//     modalClass: string;
//     validateError: boolean;
//     zIndex: number;
// }
